import React from 'react';

interface LogoProps {
  color?: 'light' | 'dark';
  darkMode?: boolean;
}

const Logo: React.FC<LogoProps> = ({ color = 'dark', darkMode = false }) => {
  return (
    <div>
      <img
        src="/sl-logo-new.png"
        alt="SL Rooms Logo"
        className={`h-12 w-auto object-contain transition-all duration-300 ${
          darkMode ? 'brightness-[0.25]' : ''
        }`}
      />
    </div>
  );
};

export default Logo;